import { types } from "../types/types";

const initialState = {
  searchFilter: {},
};

export const asientosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.getAsientosSearchFilter:
      return {
        ...state,
        searchFilter: action?.payload || initialState.searchFilter,
      };
    default:
      return state;
  }
};
